import { toJSON, unique } from "../utils";
import { NFTEventWhitelist } from "./whitelist";
export var VerificationError;
(function (VerificationError) {
    VerificationError["INVALID"] = "invalid_code";
    VerificationError["NOT_ELIGIBLE"] = "not_eligible";
    VerificationError["REGISTRATION_REQUIRED"] = "registration_required";
    VerificationError["NFT_HOLDER_ONLY"] = "nft_holder_only";
    VerificationError["EVENT_NOT_STARTED"] = "event_not_started";
    VerificationError["EVENT_ENDED"] = "event_ended";
    VerificationError["EXPIRED"] = "code_expired";
    VerificationError["MISSING_NFT_COLLECTION"] = "missing_nft_collection";
    VerificationError["UNKNOWN_EVENT"] = "unknown_event";
    VerificationError["UNKNOWN_NFT_COLLECTION"] = "unknown_nft_collection";
    VerificationError["USAGE_LIMIT_EXCEEDED"] = "usage_limit_exceeded";
    VerificationError["INVALID_SESSION"] = "invalid_session";
    VerificationError["INVALID_WALLET"] = "invalid_wallet";
    VerificationError["USAGE_RECORD_ERROR"] = "error_saving_record";
})(VerificationError || (VerificationError = {}));
export class NFTEventTierVerificationResult {
    constructor(params) {
        var _a;
        this.eventId = params.eventId;
        this.tierId = params.tierId;
        this.eligible = !!params.eligible;
        this.validCount = (_a = params.validCount) !== null && _a !== void 0 ? _a : (this.eligible ? 1 : 0);
        this.userId = params.userId || "";
        this.email = params.email || "";
        this.wallets = params.wallets || [];
        this.identifiers = unique([
            ...(params.identifiers || []),
            ...this.wallets,
            this.userId,
            this.email.toLowerCase(),
        ]);
        if (params.validNFTCollections)
            this.validNFTCollections = params.validNFTCollections;
        if (params.validWhitelist)
            this.validWhitelist = new NFTEventWhitelist(params.validWhitelist);
    }
    get json() {
        return toJSON(this);
    }
}
